// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
} from '@heroicons/react/24/outline';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const Header = ({ isAuthenticated, user, handleLogin, handleLogout }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  // State for modal visibility and form type
  // const [authModalIsOpen, setAuthModalIsOpen] = useState(false);
  // const [isLoginForm, setIsLoginForm] = useState(true);

  // const userMenuRef = useRef(null);
  const locationsMenuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (navOpen) {
        return;
      }

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setShowHeader(false);
      } else if (currentScrollY < lastScrollY) {
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, navOpen]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       userMenuRef.current &&
  //       !userMenuRef.current.contains(event.target)
  //     ) {
  //       setUserMenuOpen(false);
  //     }
  //     if (
  //       locationsMenuRef.current &&
  //       !locationsMenuRef.current.contains(event.target)
  //     ) {
  //       setLocationsOpen(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  // Define a mid-gray color for the navigation links
  const navLinkColor = ' text-gray-700';

  return (
    <header
      className={`fixed w-full z-20 bg-background drop-shadow-2xl transition-transform duration-700 ease-in-out transform-gpu ${
        showHeader ? 'translate-y-0' : '-translate-y-[100%]'
      }`}
    >
      <div className="container mx-auto px-4 flex items-center justify-between h-16">
        {/* Left Section: Logo and Brand Name */}
        <div className="flex items-center">
          <img
            src="/assets/unity_living_logo.webp"
            alt="Unity Living Logo"
            className="w-10 h-10 mr-2"
          />
          <HashLink
            to="/#top"
            className={`font-heading text-xl font-bold text-primary${navLinkColor}`}
          >
            Unity Living
          </HashLink>
        </div>

        {/* Center Section: Navigation Links */}
        <nav className="hidden md:flex items-center space-x-8">
          <HashLink
            smooth
            to="/#about-us"
            className={`text-lg hover:text-secondary transition duration-300${navLinkColor}`}
          >
            About Us
          </HashLink>

          {/* Locations Dropdown */}
          <div ref={locationsMenuRef} className="relative">
            <button
              onClick={() => {
                setLocationsOpen(!locationsOpen);
                setUserMenuOpen(false);
              }}
              className={`text-lg hover:text-secondary transition duration-300 flex items-center${navLinkColor}`}
            >
              Locations
              <ChevronDownIcon className="h-5 w-5 ml-1" />
            </button>
            {locationsOpen && (
              <div className="absolute mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg">
                <Link
                  to="/locations/Paradise Valley - Phoenix"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={() => setLocationsOpen(false)}
                >
                  Paradise Valley - Phoenix
                </Link>
                {/* Add more locations here if needed */}
              </div>
            )}
          </div>

          <HashLink
            smooth
            to="/#contact-us"
            className={`text-lg hover:text-secondary transition duration-300${navLinkColor}`}
          >
            Contact Us
          </HashLink>
        </nav>

        {/* Right Section: Phone Number, User Icon, and Mobile Menu Button */}
        <div className="flex items-center">
          {/* Phone Number (Desktop) */}
          <a
            href="tel:6028101856"
            className={`hidden md:block ml-6 text-lg font-medium hover:text-secondary transition duration-300${navLinkColor}`}
          >
            (602) 810-1856
          </a>

          {/* User Menu */}
          <div /*ref={userMenuRef}*/ className="relative ml-4">
            <button
              onClick={() => {
                // setUserMenuOpen(!userMenuOpen);
                setLocationsOpen(false);
              }}
              className="flex items-center focus:outline-none"
              aria-haspopup="true"
              // aria-expanded={userMenuOpen}
            >
              {/* <img
                src="/assets/user.png"
                alt="User Menu"
                className="h-8 w-8 rounded-full object-cover border border-gray-300"
              /> */}
            </button>
            {/* {userMenuOpen && (
              <div className="absolute right-0 md:right-0 md:left-auto left-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                {!isAuthenticated ? (
                  <>
                    <button
                      onClick={() => {
                        setAuthModalIsOpen(true);
                        setIsLoginForm(true);
                        setUserMenuOpen(false);
                      }}
                      className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      Login
                    </button>
                    <button
                      onClick={() => {
                        setAuthModalIsOpen(true);
                        setIsLoginForm(false);
                        setUserMenuOpen(false);
                      }}
                      className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      Register
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/account"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={() => setUserMenuOpen(false)}
                    >
                      My Account
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setUserMenuOpen(false);
                      }}
                      className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </>
                )}
              </div>
            )} */}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden ml-2">
            <button
              onClick={() => setNavOpen(!navOpen)}
              aria-label="Toggle Menu"
            >
              {navOpen ? (
                <XMarkIcon
                  className={`h-6 w-6 text-primary${navLinkColor}`}
                />
              ) : (
                <Bars3Icon
                  className={`h-6 w-6 text-primary${navLinkColor}`}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {navOpen && (
        <nav className="md:hidden bg-background shadow-lg">
          <HashLink
            smooth
            to="/#about-us"
            className="block px-4 py-2 hover:bg-gray-100"
            onClick={() => setNavOpen(false)}
          >
            About Us
          </HashLink>

          {/* Locations Dropdown */}
          <div className="border-t border-b border-gray-200">
            <button
              onClick={() => setLocationsOpen(!locationsOpen)}
              className="w-full flex items-center justify-between px-4 py-2 hover:bg-gray-100"
            >
              Locations
              <ChevronDownIcon className="h-5 w-5" />
            </button>
            {locationsOpen && (
              <div className="bg-white">
                <Link
                  to="/locations/Paradise Valley - Phoenix"
                  className="block px-6 py-2 hover:bg-gray-100"
                  onClick={() => {
                    setNavOpen(false);
                    setLocationsOpen(false);
                  }}
                >
                  Paradise Valley - Phoenix
                </Link>
                {/* Add more locations here if needed */}
              </div>
            )}
          </div>

          <HashLink
            smooth
            to="/#contact-us"
            className="block px-4 py-2 hover:bg-gray-100"
            onClick={() => setNavOpen(false)}
          >
            Contact Us
          </HashLink>

          {/* User Options */}
          {/* <div className="border-t border-gray-200">
            {!isAuthenticated ? (
              <>
                <button
                  onClick={() => {
                    setAuthModalIsOpen(true);
                    setIsLoginForm(true);
                    setNavOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    setAuthModalIsOpen(true);
                    setIsLoginForm(false);
                    setNavOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 border-t border-gray-200"
                >
                  Register
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/account"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={() => setNavOpen(false)}
                >
                  My Account
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setNavOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 border-t border-gray-200"
                >
                  Logout
                </button>
              </>
            )}
          </div> */}

          <a
            href="tel:6028101856"
            className="block px-4 py-2 hover:bg-gray-100 border-t border-gray-200"
          >
            (602) 810-1856
          </a>
        </nav>
      )}

      {/* Authentication Modal */}
      {/* <Modal
  isOpen={authModalIsOpen}
  onRequestClose={() => setAuthModalIsOpen(false)}
  contentLabel="Authentication Modal"
  className="modal-content"
  overlayClassName="modal-overlay"
  ariaHideApp={false}
> */}
  {/* Close Button */}
  {/* <button
    onClick={() => setAuthModalIsOpen(false)}
    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
  >
    &times;
  </button> */}

  {/* Render the appropriate form */}
  {/* {isLoginForm ? (
    <LoginForm
      switchToRegister={() => setIsLoginForm(false)}
      onLogin={(userData) => {
        setAuthModalIsOpen(false);
        setUserMenuOpen(false);
        handleLogin(userData); // Use handleLogin from props
      }}
    />
  ) : (
    <RegisterForm
      switchToLogin={() => setIsLoginForm(true)}
      onRegister={(userData) => {
        setAuthModalIsOpen(false);
        setUserMenuOpen(false);
        handleLogin(userData); // Use handleLogin from props
      }}
    />
  )}
</Modal> */}
    </header>
  );
};

export default Header;
